import { supapfolioV3Client } from '../supapress-v3/supapress-v3-utilities.js'
import { elementReady } from '../utilities.js'

export class AlgoliaDataList {
  constructor () {
    this.client = supapfolioV3Client()
    this.search = this.client.search({
      source: 'products'
    })
  }

  algoliaDataArrayMapping () {
    return {
      categories: 'hierarchicalCategories.lvl0',
      imprints: 'imprint',
      authors: 'contributorByLine',
      series: 'series'
    }
  }

  async showAlgoliaLists () {
    const listMapping = this.algoliaDataArrayMapping()
    const algoliaLists = document.querySelectorAll('[id$=-facet-wrapper]')
    if (!algoliaLists.length) {
      return ''
    }

    algoliaLists.forEach((list) => {
      if (!list.id) {
        return ''
      }
      const algoliaListID = list.id
      const dataType = algoliaListID.substr(0, algoliaListID.indexOf('-'))

      if (!listMapping[dataType]) {
        return ''
      }
      this.hierarchicalMenuFilterWidget(algoliaListID, listMapping[dataType])

      this.clearSdkClickEvents(`#${algoliaListID} .algolia-list`)
    })

    this.search.start()
  }

  hierarchicalMenuFilterWidget (algoliaListID, listMapping) {
    return this.search.addWidget(
      this.search.widgets.hierarchicalMenuFilter({
        container: `#${algoliaListID}`,
        attributes: [listMapping],
        sortBy: ['isRefined', 'name:asc'],
        limit: 100,
        collapsible: false,
        showMore: false,
        templates: {
          header: '',
          item: '<a href="{{ url }}" class="{{classes.link}}">{{ name }}</a>'
        },
        classes: {
          wrapper: 'algolia-list',
          body: 'algolia-list__body',
          list: 'algolia-list__inner',
          item: 'algolia-list__item',
          active: 'algolia-list__item--active',
          link: 'algolia-list__item--link'
        },
        resultHandler: this.algoliaDataListResultsHandler.bind(this)
      })
    )
  }

  algoliaDataListResultsHandler (item) {
    let parameter = item.url.split('?').pop()
    parameter = parameter.replace('hFR', 'dFR')
    parameter = parameter.replace('[hierarchicalCategories]', '[hierarchicalCategories.lvl0]')
    item.name = item.name.toLowerCase()
    item.url = `/search/?${parameter}`
    return item
  }

  clearSdkClickEvents (list) {
    elementReady(list).then((links) => {
      links.querySelectorAll('.algolia-list__item a').forEach((item) => {
        item.addEventListener('click', (e) => {
          e.stopPropagation()
        })
      })
    })
  }
}
